<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>平台商户近3个月销售汇总</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                [商户ID]商户昵称
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                销售总额
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                健康状态
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                入驻时间
              </th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="merchant in merchSums" :key="merchant.deliver_id">
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <soft-avatar
                      :img="defaultAvatar"
                      size="sm"
                      border-radius="lg"
                      class="me-3"
                      alt="user1"
                    />
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ merchant.deliver_id }}</h6>
                    <p class="text-xs text-secondary mb-0">
                      {{ merchant.nick_name || "加载中..." }}
                    </p>
                  </div>
                </div>
              </td>
              <td>
                <p class="text-s font-weight-bold mb-0">
                  <i class='fa fa-arrow-up text-success'></i>
                  {{ merchant.sum_fee }}
                </p>
              </td>
              <td class="align-middle text-center text-sm">
                <soft-badge color="success" variant="gradient" size="sm"
                  >Online</soft-badge
                >
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold"
                  >{{ merchant.created_date ? this.formatDate(merchant.created_date) : "加载中..."}}</span
                >
              </td>
              <td class="align-middle">
                <a
                  href="javascript:;"
                  class="text-secondary font-weight-bold text-xs"
                  @click="showDetailModal(merchant.deliver_id)"
                  >详情</a
                >
              </td>
            </tr>      
          </tbody>
        </table>
      </div>
    </div>
  </div>

<!--弹窗-->
<div v-if="isModalVisible" class="modal-overlay">
  <div class="modal-content card">
    <div class="card-header pb-0">
      <h6>商户-{{ merchMap[currentMerchantId] || '加载中...' }}</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7">设备ID</th>
              <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 ps-2">商户ID</th>
              <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 ps-2">店铺名</th>
              <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 ps-2">统计起点</th>
              <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 ps-2">统计截止</th>          
              <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 ps-2">实收金额</th>
              <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 ps-2">出币数量</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in filteredStatisticData" :key="item.board_id">
              <td>{{ item.board_id }}</td>
              <td>{{ item.deliver_id }}</td>
              <td>{{ shopMap[item.shop_id] || '加载中...'}}</td>
              <td>{{ this.formatDate(item.start_date) }}</td>
              <td>{{ this.formatDate(item.end_date) }}</td>
              <td>{{ (item.sum_fee/100.0).toFixed(2) }}</td>
              <td>{{ (item.sum_coins/100.0).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button class="modal-button" @click="closeModal">关闭</button>
      </div>
    </div>

  </div>
</div>

</template>

<script>
import SoftAvatar from "@/components/SoftAvatar.vue";
import SoftBadge from "@/components/SoftBadge.vue";
//import SoftButton from "@/components/SoftButton.vue";
import { getMerchantTotalSales } from "@/api/statistic"
import { getmerchbyid } from "@/api/merch"
import { formatDate } from "@/utils/dateformat"
import { reactive } from "vue";
import { getAllShops } from "@/api/shop"

export default {
  name: "authors-table",
  data() {
    return {
      defaultAvatar: require("../../assets/img/merchant.png"),
      statisticData : [],
      merchSums:[],
      isModalVisible: false,
      currentMerchantId: null,
      merchMap:reactive({}),
      shopMap:reactive({}),
    };
  },
  components: {
    SoftAvatar,
    SoftBadge,
    //SoftButton,
  },
  methods: {
    async fetchLastThreeMonSums(){
      try{
        const resp = await getMerchantTotalSales()
        console.log("total sums:", resp)
        this.statisticData = resp.desc
        this.calcMerchSums()
      }catch(error){
        alert("请求失败")
      }
    },

    calcMerchSums(){
      const sumsByDeliverId = {}
      this.statisticData.forEach((item) => {
        const{ deliver_id, sum_fee } = item
        if (!sumsByDeliverId[deliver_id]) {
          sumsByDeliverId[deliver_id] = 0
        }
        sumsByDeliverId[deliver_id] += sum_fee/100.0
      })
      this.merchSums = Object.entries(sumsByDeliverId).map(([deliver_id, sum_fee])=>{
        return {deliver_id, sum_fee:parseFloat(sum_fee.toFixed(2))}
      })
      this.fetchMerchDetails()
      console.log("汇总结果:", this.merchSums)
    },

    async fetchMerchDetails() {
      for (const merchant of this.merchSums) {
        try {
          const resp = await getmerchbyid({
            deliver_id:merchant.deliver_id
          })
          if (resp.code === 0){
           this.merchMap[merchant.deliver_id] = resp.desc.nick_name
            merchant.nick_name = resp.desc.nick_name
            merchant.created_date = resp.desc.created_date  
          }else{
            console.log(resp.desc)
          }          
        }catch(error){
          console.log("try to get merchant info err:", error)
        }
      }
    },

    formatDate,

    showDetailModal(deliver_id) {
      this.currentMerchantId = deliver_id
      this.isModalVisible = true
      console.log("过滤后的数据：", this.filteredStatisticData);
    },

    closeModal(){
      console.log("closing modal")
      this.currentMerchantId = null
      this.isModalVisible = false
      this.$emit("close")
    },

    async getAllShopNames(){
      try{  
        const resp = await getAllShops()
        if (resp.code === 0) {
           resp.desc.forEach((item)=> {
              this.shopMap[item.shop_id] = item.shop_name
           })
        }else{
          console.log("get shops err:", resp.desc)
        }
      }catch(error){
        console.log("get shops info err:", error)
      }

    },

  },
  mounted(){
    this.fetchLastThreeMonSums()
    this.getAllShopNames()
  },

  computed: {
    filteredStatisticData(){
      console.log("当前商户ID：", this.currentMerchantId);
      console.log("统计数据：", this.statisticData, "delivernick:", this.merchMap);
      console.log("filtering data for table, curmerchid:", this.currentMerchantId)
      if (!this.currentMerchantId) return []
      return this.statisticData.filter(
        (item) => String(item.deliver_id) === String(this.currentMerchantId)
      )
    }
  }
};
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-content {
  width: 80%;
  max-width: 900px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.modal-footer {
  text-align: left; /* 居中 */
  padding: 10px;
}

.modal-button {
  margin: 0; /* 清除默认外边距 */
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>


